import * as React from 'react'
import Head from 'next/head'
import { getPosts } from '../../asyncLoaders/buttercms'
import Layout from '../../components/Layout'
import { Container } from '../../components/Container'
import BlogRoll from '../../components/BlogPage/BlogRoll'
import { BlogSidebar } from '../../components/BlogPage/BlogSidebar'

const BlogIndex = ({ allPosts, preview }) => {
  return (
    <Layout title={'Blog - NuBrakes Mobile Brake Repair'} preview={preview}>
      <Head>
        <meta name="description" content="Recent brake repair posts and news from NuBrakes." />
        <title>Blog - NuBrakes Mobile Brake Repair</title>
      </Head>
      <section>
        <Container>
          <div className="grid md:grid-cols-12 gap-4">
            <div className="md:col-span-8">
              <BlogRoll posts={allPosts} />
            </div>
            <div className="md:col-span-4">
              <BlogSidebar posts={allPosts} />
            </div>
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export type BlogPostType = {
  status: string
  created: Date
  updated: Date
  published: Date
  title: string
  slug: string
  body: string
  summary: string
  seo_title: string
  meta_description: string
  featured_image_alt: string
  url: string
  featured_image: string
  author: any
  tags: string[]
  categories: string[]
}

export default BlogIndex

export const getStaticProps = async ({ preview = null }) => {
  const allPosts = (await getPosts(preview)) || []
  return { props: { allPosts, preview } }
}
